<template>
  <div class="info-row">
    <slot></slot>
  </div>
</template>

<script>
export default {};
</script>

<style scoped>
.info-row {
  &:not(:last-child) {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
}
</style>
